export default __webpack_public_path__ + "bdc54f5.woff";